export default __webpack_public_path__ + "static/media/Client_Agreement.7f3475e0.pdf";